const FIBER_SPEED_LABEL_KEYS = {
  100: 'productLabels.everydayEssentials',
  300: 'productLabels.smartChoice',
  250: 'productLabels.businessReady',
  500: 'productLabels.customerFavorite',
  700: 'productLabels.highPerformance',
  1000: 'productLabels.seamlessPower',
  2000: 'productLabels.supercharged',
  5000: 'productLabels.unstoppableSpeed',
};

const FIBER_SPEED_NAME_KEYS = {
  100: 'productNames.fiber100Mbps',
  250: 'productNames.fiber250Mbps',
  300: 'productNames.fiber300Mbps',
  500: 'productNames.fiber500Mbps',
  700: 'productNames.fiber700Mbps',
  1000: 'productNames.fiber1Gig',
  2000: 'productNames.fiber2Gig',
  5000: 'productNames.fiber5Gig',
};

export const getMbpsFromPlan = (plan) => {
  if (plan?.downstreamSpd) {
    return Number(plan.downstreamSpd) / 1000;
  }
  const match = String(plan?.downstreamSpeed || '').match(/(\d+)\s*(mb|gb)/i);
  if (!match) {return 0;}
  const value = parseInt(match[1], 10);
  return match[2].toLowerCase() === 'gb' ? value * 1000 : value;
};

const isWirelessUnlimited = (plan) => {
  const servCode = String(plan?.servCode || '').toLowerCase();
  const serviceName = String(plan?.serviceName || '').toLowerCase();
  const isWirelessCode = servCode === 'whi' || servCode === 'elfw' || servCode === 'fixwireless';
  return isWirelessCode && serviceName.includes('unlimited');
};

export const isFiber = (plan) => {
  const servCode = String(plan?.servCode || '').toLowerCase();
  if (servCode === 'ipbb') {return true;}
  return Boolean(plan?.downstreamSpeed);
};

export const isFiberServiceable = (plan) =>
  String(plan?.servCode || '').toLowerCase() === 'ipbb';


const isWirelessUnlimitedByName = (plan) =>
  String(plan?.serviceName || '').toLowerCase().includes('unlimited');

export const getProductLabel = (plan, t, isConsumer) => {
  if (!plan) {return null;}
  if (isConsumer && isWirelessUnlimitedByName(plan)) {
    return t ? t('productLabels.customerFavorite') : 'CUSTOMER FAVORITE';
  }
  if (isWirelessUnlimited(plan)) {
    return t ? t('productLabels.mostPopularPlan') : 'MOST POPULAR PLAN';
  }
  if (isFiber(plan)) {
    const key = FIBER_SPEED_LABEL_KEYS[getMbpsFromPlan(plan)];
    if (!key) {return null;}
    return t ? t(key) : key;
  }
  return null;
};


export const getConsumerPlanName = (plan, t) => {
  if (!plan) {return null;}
  if (isWirelessUnlimitedByName(plan)) {
    return t ? t('productNames.fiveGUnlimited') : '5G Unlimited';
  }
  if (isFiber(plan)) {
    const key = FIBER_SPEED_NAME_KEYS[getMbpsFromPlan(plan)];
    return key ? (t ? t(key) : key) : null;
  }
  return null;
};
